import { globby } from 'globby';

export function getFiles(cwd: string) {
  return globby(['**'], { cwd, dot: true, onlyFiles: true });
}
